/**
 * Call to action:
 * 0: Free sensor when you sign up by the end of MONTH
 * 1: fmc
 * 
 * Call to action image:
 * 0: apples
 * 1: app
 */
export const regions = {
  bundaberg: {
    allowSignUp: false,
    cta: 0,
    ctaImage: 1,
    name: 'bundaberg',
    referralFactory: false,
    requireSignIn: false,
    showSignIn: false,
    showHelpButton: true,
    sponsored: false 
  },
  shepparton: {
    allowSignUp: false,
    cta: 1,
    ctaImage: 1,
    name: 'shepparton',
    referralFactory: false,
    requireSignIn: false,
    showSignIn: false,
    showHelpButton: false,
    sponsored: true
  },
  sunraysia: {
    allowPremium: 'loggedIn',
    allowSignUp: false,
    cta: 0,
    ctaImage: 0,
    name: 'sunraysia',
    referralFactory: false,
    requireSignIn: false,
    showSignIn: false,
    showHelpButton: true,
    sponsored: false,
    subregions: [
      'mildura',
      'robinvale',
      'swan-hill'
    ]
  }
};
